import React from "react";
const ToolTipsLista = React.memo((props) =>
  (<div className="list-tooltips">
    <ul className="list-group list-group-flush">

      {props.listaIds && props.listaIds.length ?
        props.listaIds.slice(0, 5).map((item, index) => {
          return <li key={`${index}`} className="list-group-item">{item}</li>
        })
        : ""
      }
      {props.listaIds && props.listaIds.length > 6 ?
        <li className="list-group-item">{props.listaIds.length - 6} más </li> : ""
      }
    </ul>
  </div >
  ));


export default ToolTipsLista;
